import apiClient from './ApiService'

export default {
  getUsuarios(page = 1, limit = 15, filters = {}) {
    return apiClient.get('/usuarios', {
      params: {
        page,
        limit,
        ...filters
      }
    })
  },
  
  getUsuario(id) {
    return apiClient.get(`/usuarios/${id}`)
  },
  
  createUsuario(usuario) {
    return apiClient.post('/usuarios', usuario)
  },
  
  updateUsuario(id, usuario) {
    return apiClient.put(`/usuarios/${id}`, usuario)
  },
  
  deleteUsuario(id) {
    return apiClient.delete(`/usuarios/${id}`)
  },
  
  exportarListado(formato, filtros = {}) {
    return apiClient.get('/usuarios/exportar', {
      params: {
        formato,
        ...filtros
      },
      responseType: 'blob'
    })
  },

  getGestionesFederacion(idUsuario) {
    return apiClient.get(`/usuarios/${idUsuario}/gestiones-federacion`)
  },

  getGestionesOrganizacion(idUsuario) {
    return apiClient.get(`/usuarios/${idUsuario}/gestiones-organizacion`)
  }
}